import {
  Box,
  FormControl,
  FormLabel,
  Input,
  Tag,
  TagCloseButton,
  TagLabel,
  Wrap,
} from "@chakra-ui/react";
import React from "react";

const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

type Props = {
  value: string[];
  onChange: (emails: string[]) => void;
};

export default function RecipientEmailsInput({ onChange, value }: Props) {
  const [draft, setDraft] = React.useState("");

  const commit = () => {
    const email = draft.trim();
    if (EMAIL_RE.test(email) && !value.includes(email)) {
      onChange([...value, email]);
      setDraft("");
    }
  };

  return (
    <FormControl isRequired>
      <FormLabel>Recipient emails</FormLabel>
      <Wrap mb={2}>
        {value.map((email) => (
          <Tag key={email}>
            <TagLabel>{email}</TagLabel>
            <TagCloseButton onClick={() => onChange(value.filter((e) => e !== email))} />
          </Tag>
        ))}
      </Wrap>
      <Box>
        <Input
          placeholder="name@agency.com, press Enter"
          value={draft}
          onBlur={commit}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") {
              e.preventDefault();
              commit();
            }
          }}
        />
      </Box>
    </FormControl>
  );
}
